import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

import { useStyles } from "./PostMailResetPassword.css";
import { withRouter } from "react-router";

class PostMailResetPassword extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          We have send a password reset link to your email address
        </div>
        <Button
          variant="outlined"
          className={classes.buttonStyle}
          onClick={() => this.props.history.push(`/login/${this.props.type}`)}
        >
          Return to Login
        </Button>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(PostMailResetPassword));
